module.exports = __webpack_public_path__ + "img/galicia.4eb9b41c.svg";